import React from "react";
import { Button, notification } from "antd";
import { useSendOtpMutation } from "store/api";
import { ErrorAlert, Logo } from "components/Common";
import InputField from "components/Common/InputField";
import { Formik } from "formik";
import * as Yup from "yup";
import { Link, useNavigate } from "react-router-dom";

const AccountLocked = () => {
  const [error, setError] = React.useState<string | null>(null);
  const navigate = useNavigate();

  const [sendOtp, { isLoading: isSendingOtp }] = useSendOtpMutation();
  const onFinish = async (values: any) => {
    try {
      await sendOtp(values).unwrap();
      navigate("/verify-otp", { state: { email: values.email } });
      notification.success({
        message: "Please check your email inbox, OTP is sent",
      });
    } catch (error: any) {
      setError(error?.data?.error || "Failed to send OTP. Please try again.");
    }
  };

  return (
    <div className="w-full h-full flex items-center justify-center">
      <div className="w-full h-full flex flex-col justify-center">
        <Logo />
        <h1 className="text-2xl font-bold mb-1 text-center">Account Locked</h1>
        <p className="mb-4 text-center">
          Enter your email to unlock your account
        </p>

        <Formik
          validateOnBlur
          initialValues={{
            email: "",
          }}
          validationSchema={Yup.object().shape({
            email: Yup.string()
              .email("Invalid email address")
              .required("Email is required"),
          })}
          onSubmit={async (values) => {
            await onFinish(values);
          }}
        >
          {({ handleSubmit, isValid, dirty }) => (
            <form onSubmit={handleSubmit} className="space-y-3">
              <ErrorAlert type="error" message={error} setMessage={setError} />
              <InputField
                label="Email"
                name="email"
                type="email"
                placeholder="Enter email"
              />

              <Button
                type="primary"
                htmlType="submit"
                className="w-full h-10"
                loading={isSendingOtp}
                disabled={!isValid || !dirty || isSendingOtp}
              >
                Continue
              </Button>
            </form>
          )}
        </Formik>
        <div className="flex items-center justify-end p-3 gap-2">
          <Link to="/" className="text-blue-500">
            Back to login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AccountLocked;
